var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-container",
      style: {
        width: _vm._width,
        paddingBottom: _vm.$slots.footer ? `${_vm.footerHeight}px` : 0,
      },
    },
    [
      _c(
        "header",
        {
          staticClass: "v-container__header",
          style: { height: `${_vm.headerHeight}px` },
        },
        [_vm._t("header")],
        2
      ),
      _c(
        "nav",
        { staticClass: "v-container__nav", style: { width: _vm._asideWidth } },
        [_vm._t("aside")],
        2
      ),
      _c(
        "section",
        {
          staticClass: "v-container__main",
          style: {
            paddingLeft: _vm._asideWidth,
            paddingTop: `${_vm.headerHeight}px`,
          },
        },
        [_vm._t("default")],
        2
      ),
      _vm.$slots.footer
        ? _c(
            "footer",
            {
              staticClass: "v-container__footer",
              style: {
                height: `${_vm.footerHeight}px`,
                paddingLeft: _vm._asideWidth,
              },
            },
            [_vm._t("footer")],
            2
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }